// extracted by mini-css-extract-plugin
module.exports = {"coinSelector":"CoinSelector_coinSelector__2igoQ","separator":"CoinSelector_separator__3R6Lt"};